/* eslint-disable */

import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import PARSE from "html-react-parser";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import clsxm from "../../context/clsxm";
import Api from "./Api";
import { Link } from "react-router-dom";

const api = new Api();

const containerStyle = {
  width: "100%",
  height: "100%",
};

const lib = ["drawing", "places"];

export default function SSoft_Our_Offices() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [title, setTitle] = useState(null);
  const [listLine, setListLine] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const [userLat, setUserLat] = useState();
  const [userLong, setUserLong] = useState();

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCKqMs4hmNgoQtmIUsd7diBKHj6UV610Jg",
    libraries: lib,
  });

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setTitle(section?.widget_contents[0]);
              setListLine(section?.widget_contents);
              break;
            }
            case 1: {
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++;
        });

        if (switchCaseCompleted === 1) {
          setLoaded(true);
        }
      }
    }
  }, [sections]);

  useEffect(() => {
    if (loaded && title?.location?.latitude && title?.location?.longitude) {
      setUserLat(title?.location?.latitude);
      setUserLong(title?.location?.longitude);
    }
  }, [loaded, title]);

  const center = {
    lat: +userLat,
    lng: +userLong,
  };

  return loaded ? (
    <div className=" w-full relative py-[120px] bg-[#FAF8F5] ">
      <div className="section-container section-margin-x ">
        <div className="hdxl:text-[16px] text-[14px] font-[500] leading-[120%]  pb-[15px] tracking-[0.42px]">
          {title?.article_language?.title}
        </div>
        <div className="pb-[15px] header-style-non-hero">
          {title?.article_language?.summary}
        </div>
        <div className="py-[80px] grid lg:grid-cols-2 grid-cols-none lg:grid-rows-none grid-rows-2 gap-y-[45px]">
          <div className="flex flex-col space-y-[40px]">
            {listLine?.map((list, i) => {
              return (
                i > 0 && (
                  <div
                    className={clsxm(
                      "border-l-[2px] pl-[32px]",
                      i === 1 ? "border-newDarkBlue" : "border-[#FAF8F5]"
                    )}
                  >
                    <div className="content-header-style-non-hero pb-[10px]">
                      {list?.article_language?.title}
                    </div>
                    <div className="content-subheader-style-non-hero pb-[15px]">
                      {PARSE(list?.article_language?.content)}
                    </div>

                    <div className="flex space-x-[6px] items-center">
                      <img
                        src={list?.assets[0]?.asset_file}
                        alt=""
                        className="w-[18px] h-[18px]"
                      />
                      <a
                        target="_blank"
                        href={list?.article_language?.path || "/"}
                        className=""
                      >
                        <div className="text-[14px] leading-[150%] text-[#255262]">
                          {list?.article_language?.summary}
                        </div>
                      </a>
                    </div>
                  </div>
                )
              );
            })}
          </div>
          <div className="">
            {isLoaded && center?.lat && center?.lng ? (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={20}
              >
                {/* Child components, such as markers, info windows, etc. */}
                <MarkerF
                  position={{
                    lat: parseFloat(userLat),
                    lng: parseFloat(userLong),
                  }}
                />
              </GoogleMap>
            ) : (
              <Skeleton width={"100%"} className=" h-full w-full" />
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="section-container section-margin-x">
      <Skeleton
        width={"100%"}
        className=" lg:h-[373px] s:h-[600px] h-[700px]"
      />
    </div>
  );
}
